module.exports = __webpack_public_path__ + "img/202509_01.7a135a31.jpg";